<template>
  <header class="main-header sticky-top w-100 bg-white">
    <nav class="navbar navbar-expand-xl navbar-dark sticky-header affix" :style="{ 'box-shadow': 'none'}">
      <div
        class="container d-flex align-items-center justify-content-lg-between position-relative"
      >
        <a
          href="https://www.mywingio.com/" 
          class="navbar-brand d-flex align-items-center mb-md-0 text-decoration-none"
        >
        &nbsp;<img
            src="assets/img/logo-text.png"
            alt="logo"
            class="img-fluid logo-color"
        />
        </a>

        <a
          class="navbar-toggler position-absolute right-0 border-0"
          href="#offcanvasWithBackdrop"
          role="button"
        >
          <span
            class="far fa-bars fa-xl"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasWithBackdrop"
            aria-controls="offcanvasWithBackdrop"
          ></span>
        </a>
        <a href="javascript:void(0)" @click="$router.push({ path: '/cart'})" class="text-black-custom cart-mobile">
              <i class="fa fa-shopping-cart fa-xl" aria-hidden="true"></i>
              <span class='badge badge-warning' id='lblCartCount'> {{ cartItemsCount }} </span>
        </a>

        <div class="clearfix"></div>
        <div class="collapse navbar-collapse justify-content-end">
          <ul class="nav col-12 col-md-auto justify-content-center main-menu">
            <li><a class="nav-link" href="https://www.mywingio.com/">Home</a></li>
            <li><a class="nav-link custom-underline" href="javascript:void(0)" @click="$router.push({ path: '/'})">Shop</a></li>
            <!--<li><a class="nav-link" href="javascript:void(0)" @click="$router.push({ path: '/prices'})">Plan</a></li>-->
            <!--<li>
              <a class="nav-link" href="javascript:void(0)" @click="$router.push({ path: '/faq'})">FAQ</a>
            </li>
            <li class="nav-item dropdown">
              <a href="javascript:void(0)" @click="$router.push({ path: '/contact-us'})" class="nav-link"> Contact Us </a>
            </li>
            <li>
              <a href="javascript:void(0)" @click="$router.push({ path: '/privacy-policy'})" class="nav-link"> Policy </a>
            </li>-->
          </ul>
        </div>

        <div
          class="action-btns text-end me-5 me-lg-0 d-none d-md-block d-lg-block"
        >
          <!-- <a href="login.html" class="btn btn-link text-decoration-none me-2">Sign In</a> -->
          <a href="https://parent.mywingio.com/login" class="btn btn-primary btn-sm"
            >Login</a
          >&nbsp;
            <a href="javascript:void(0)" @click="$router.push({ path: '/cart'})" class="text-black-custom">
                <i class="fa fa-shopping-cart fa-xl" aria-hidden="true"></i>
                <span id="checkout_items" class="checkout_items">{{ cartItemsCount }}</span>
            </a>
        </div>

        <!--offcanvas menu start-->
        <div
          class="offcanvas offcanvas-start bg-purple"
          tabindex="-1"
          id="offcanvasWithBackdrop"
        >
          <div class="offcanvas-header d-flex align-items-center mt-4">
            <a
              href="javascript:void(0)"
              class="d-flex align-items-center mb-md-0 text-decoration-none"
            >
              <img
                src="assets/img/logo-color.png"
                alt="logo"
                class="img-fluid ps-2"
                :style="{ width: '25%' }"
              />
            </a>
            <a
              id="closeMenubtn"
              type="button"
              class="text-black-custom"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i class="far fa-close fa-xl"></i>
            </a>
          </div>
          <div class="offcanvas-body">
            <ul class="nav col-12 col-md-auto justify-content-center main-menu">
              
                <li><a class="nav-link" href="https://www.mywingio.com/">Home</a></li>
                <li><a class="nav-link custom-underline" href="javascript:void(0)" @click="redirectToPage('/')">Shop</a></li>
            </ul>
            <div class="action-btns mt-4 ps-3">
              <!-- <a href="login.html" class="btn btn-outline-primary me-2">Sign In</a> -->
              <a href="https://parent.mywingio.com/login" class="btn btn-primary btn-sm"
                >Login</a
              >
            </div>
          </div>
        </div>
        <!--offcanvas menu end-->
      </div>
    </nav>
  </header>
  <!--header end-->
  <!--<div class="sticky-container">
    <ul class="sticky">
        <li>
            <img src="assets/img/whatsapp-50.png" width="50" height="50" alt="Kid Smartphone Whatsapp Number">
            <p><a href="https://api.whatsapp.com/send/?phone=447349970810&text=Please contact us on WhatsApp for a faster reply." target="_blank">Contact us <br>on Whatsapp</a></p>
        </li>
    </ul>
  </div>-->
</template>
<script>
import PaymentService from "../services/PaymentService";
export default {
  name: "Header",
  props: {
    logo: {
      type: String,
      default: "./img/logo-light.png",
    },
    whatsappLogo: {
      type: String,
      default: "./img/whatsapp-50.png",
    },
  },
  data() {
    return {
      currentRoute: this.$route.name,
      cartItemsCount: 0
    };
  },
  methods: {
    async getCartCount() {
        await PaymentService.getCartCount()
        .then((response) => {
          this.cartItemsCount = response.data.data;
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    redirectToPage(pageName) {
      this.$router.push({ path: pageName})
      $('#closeMenubtn').click();
    }
  },
  watch: {
    '$route'(to, from) {
      this.getCartCount();
    },
  },
  async beforeMount() {
    this.getCartCount();
  },
};
</script>
<style scoped>
.badge-warning {
  background: hsl(204.63, 60.91%, 56.86%) !important;;
  color: #FFFFFF !important
}

</style>